export const zh = {
  appTitle: '视弹 SightPlay',
  subtitle: '聆听 · 识别 · 提升',
  score: '得分',
  streak: '连胜',
  speed: '速度',
  accuracy: '正确率',
  bpm: 'BPM',
  midiReady: 'MIDI 已连接',
  target: '目标',
  noteNameLabel: '音名',
  solfegeLabel: '唱名',
  jianpuLabel: '简谱',
  played: '你演奏了',
  tooHigh: '偏高',
  tooLow: '偏低',
  perfect: '完美! 🎉',
  challenge: '挑战',
  aiCoach: 'AI 教练',
  step: '进度',
  thinking: '思考中...',
  defaultAi: '你好！我是AI教练。你可以问我乐理知识，或者说"帮我生成一首小星星"！',
  btnChallenge: '生成挑战',
  btnHint: '获取提示',
  btnMicStart: '开启麦克风',
  btnMicStop: '关闭麦克风',
  btnTreble: '高音谱号',
  btnBass: '低音谱号',
  micOn: '监听中',
  micError: '无法访问麦克风。',
  apiKeyError: '请提供 API Key 以使用 AI 功能。',
  challengeComplete: '挑战完成！干得漂亮。',
  fallbackTitle: '基础音阶',
  fallbackDesc: '一个简单的 C 大调上行音阶。',
  practiceTip: '熟能生巧！',
  listening: '聆听中...',
  showPiano: '显示钢琴',
  hidePiano: '隐藏钢琴',
  inputPlaceholder: '问乐理问题或生成乐谱...',
  send: '发送',
  practiceRangeLabel: '练习音域',
  practiceRangeCentral: '中央八度',
  practiceRangeUpper: '高一八度',
  practiceRangeCombined: '中央 + 高',
  rightHand: '右手',
  leftHand: '左手',
  bothHands: '双手',
  aiError: '抱歉，连接出现问题，请重试。',
  hintGreatStreak: '连续答对！继续保持！🔥',
  hintTrySlower: '试着慢一点，专注于准确度。',
  hintKeepGoing: '别放弃！注意音符在五线谱上的位置。',
  hintAwesome: '太棒了！完美命中！🎯',
  hintPracticeRange: '试试缩小练习范围来建立信心。',
  openAiChat: 'AI 教练',
  closeChat: '关闭',
  songLibrary: '曲库',
  difficulty_beginner: '初级',
  difficulty_intermediate: '中级',
  difficulty_advanced: '高级',
  allDifficulties: '全部难度',
  category_classical: '古典',
  category_folk: '民歌',
  category_exercise: '练习',
  clef: '谱号',
  trebleClef: '高音',
  bassClef: '低音',
  notes: '个音符',
  noSongsFound: '没有找到曲目',
  progress: '进度',
  time: '用时',
  exitSong: '退出',
  songNotFound: '未找到曲目',
  backToLibrary: '返回曲库',
  songCompleteTitle: '完成曲目！',
  correctNotes: '正确音符',
  retrySong: '再试一次',
  randomPractice: '随机练习',
  recTryBassTitle: '准备好挑战了吗？',
  recTryBassDesc: '高音谱号表现很棒——试试低音谱号吧！',
  recExpandRangeTitle: '扩展音域',
  recExpandRangeDesc: '你已经掌握了中央八度，试试组合音域吧！',
  recTrySongTitle: '试试弹首曲子！',
  recTrySongDesc: '你的识谱能力很强，用真实乐曲来练习吧！',
  recNarrowRangeTitle: '集中练习',
  recNarrowRangeDesc: '试试中央八度，用更少的音符建立信心。',
  recSlowDownTitle: '慢慢来',
  recSlowDownDesc: '不着急——专注于仔细识别每个音符。',
  recTryHarderSongTitle: '升级挑战！',
  recTryHarderSongDesc_intermediate: '太棒了！试试中级曲目吧。',
  recTryHarderSongDesc_advanced: '厉害！准备好挑战高级曲目了吗？',
  recKeepPracticingTitle: '继续加油！',
  recKeepPracticingDesc: '多练习几首曲目，或者试试随机识谱。',
  recApply: '试试看',
  authLoading: '加载中...',
  authLoginTitle: '欢迎回来',
  authLoginSubtitle: '使用 Passkey 登录以继续',
  authLoginButton: '登录',
  authLoginLoading: '认证中...',
  authNoAccountRegisterLink: '还没有账号？使用邀请码注册',
  authRegisterTitle: '欢迎来到 SightPlay',
  authRegisterSubtitle: '请输入邀请码来创建 Passkey',
  authInviteCodeLabel: '邀请码',
  authInviteCodePlaceholder: 'ABCD-EFGH',
  authPasskeyTitle: '什么是 Passkey？',
  authPasskeyDesc:
    'Passkey 使用设备生物识别（Face ID、Touch ID 或 Windows Hello）安全登录，无需密码。',
  authRegisterLoading: '设置中...',
  authRegisterButton: '创建 Passkey',
  inviteCodeLabel: '邀请码',
  inviteCodeValidFor: '7 天有效 • 一次性使用',
  inviteCodeCopied: '已复制！',
  inviteCodeCopy: '复制邀请码',
  inviteCodeGenerate: '生成邀请码',
  inviteCodeGenerating: '生成中...',
  inviteCodeFailed: '生成邀请码失败',
  passkeyManageTitle: '管理 Passkey',
  passkeyClose: '关闭',
  passkeyLoading: '加载中...',
  passkeyEmpty: '未找到 Passkey',
  passkeyAdded: '添加于',
  passkeyCannotRemoveLast: '无法删除最后一个 Passkey',
  passkeyRemove: '删除',
  passkeyRemoveConfirm: '确定要删除这个 Passkey 吗？',
  passkeyRemoveFailed: '删除 Passkey 失败',
  authLogoutButton: '退出登录',
  authErrorCanceled: '认证已取消，请重试。',
  authErrorNotSupportedDevice: '你的设备不支持 Passkey，请使用支持生物识别认证的设备。',
  authErrorConnectionTimeout: '连接超时，请检查网络后重试。',
  authErrorUnknown: '发生未知错误',
  authErrorPasskeysNotSupportedBrowser:
    '当前浏览器不支持 Passkey，请使用支持生物识别认证的现代浏览器。',
  authErrorRegisterOptionsFailed: '获取注册选项失败',
  authErrorRegisterVerificationFailed: '注册验证失败',
  authErrorLoginOptionsFailed: '获取登录选项失败',
  authErrorLoginVerificationFailed: '登录验证失败',
  challengeStatusComplete: '完成！',
  midiActive: 'MIDI 已连接',
  challengeStatusActive: '进行中',
  aiQuickChallengePrompt: '请为 {{clef}} 谱号生成一个简单的视奏挑战。',
  aiQuickHintPromptWithNote: '我该怎么弹 {{note}}？',
  aiQuickHintPromptFallback: '给我一个提示。',
  aiChallengeLoaded: '{{challenge}}：已加载 {{title}}（{{count}}{{notes}}）！',
  aiChallengeCompletedUserMessage: '我完成挑战了！我弹得怎么样？',
  passkeyButtonTitle: '管理 Passkey',
  aiConnectionErrorMessage: '连接 AI 失败。',
  errorBoundaryTitle: '出了点问题',
  errorBoundaryDescription: '发生了意外错误，请重试。',
  errorBoundaryRetry: '重试',
};
